import UrlHelper from 'src/utils/url.helper';

export class BudgetPages {
    public static HOME: string = UrlHelper.getFullPath('/spendsmart/home');
    public static PERSONALIZE: string = UrlHelper.getFullPath('/spendsmart/budget-categories');
    public static SETTINGS: string = UrlHelper.getFullPath('/spendsmart/settings');
    public static HISTORY: string = UrlHelper.getFullPath('/spendsmart/history');
    public static TRANSACTIONS: string = UrlHelper.getFullPath('/spendsmart/transactions');
    public static TRANSACTIONS_REVIEW: string = UrlHelper.getFullPath('/spendsmart/transactions/review');
    public static TRANSACTIONS_RULES: string = UrlHelper.getFullPath('/spendsmart/transactions/rules');
    public static INELIGIBLE: string = UrlHelper.getFullPath('/spendsmart/ineligible');
}
